<ng-content />
@if (erroMsg) {
  <p>{{this.erroMsg}}</p>
}
@if (logdebug) {
  <p>{{this.logdebug}}</p>
}


@if (!hasRecorded && !videoIsUploading) {
  <tidy-row class="extra-bottom-padding">
    <video id="stream-video" autoplay playsinline muted style="width: 100%; min-height: 339px;"></video>
  </tidy-row>
  @if (cameraStatus === 'standby') {
    <tidy-row>
      <tidy-button
        [text]="'Start Recording'"
        [action]="boundRecord"
        class="primary" />
    </tidy-row>
  }
  @if (cameraStatus === 'recording') {
    <tidy-row>
      <tidy-button
        [text]="'Stop Recording'"
        [action]="boundStop"
        class="primary" />
    </tidy-row>
  }
}

@if (videoIsUploading) {
  <tidy-card style="height:339px; padding:0px">
    <ion-skeleton-text animated style="width:100%; height:339px" />
  </tidy-card>
  <tidy-row [align]="'center'">
    <tidy-text
      [body]="'Wait until we upload your video...'" />
  </tidy-row>
}

@if (hasRecorded) {
  <tidy-row class="extra-bottom-padding">
    <video autoplay playsinline muted loop style="width: 100%; min-height: 339px;"><source [src]="awsUrl" type="video/mp4"></video>
  </tidy-row>
  <tidy-button
    [text]="'Looks Good'"
    [action]="boundSubmitVideo"
    class="primary"
    style="padding-bottom:10px" />
  <tidy-button
    [text]="'Try Again'"
    [action]="boundSetStream"
    class="secondary" />
}
